import { render } from "./ResetPasswordByMobile.vue?vue&type=template&id=b255b4b2"
import script from "./ResetPasswordByMobile.vue?vue&type=script&lang=js"
export * from "./ResetPasswordByMobile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__